import { Link } from 'react-router-dom'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { useLanguage } from '../context/LanguageContext';
import logo from "../Image/logo.png";
import orologo from "../Image/oro-logo.jpeg";
import mpcst from "../Image/newmpcst-logo.jpg";
import { Box, Toolbar, Typography, TextField, Select, FormControl, MenuItem, InputLabel, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import React from 'react';

const Header = () => {
//   const { t } = useLanguage();
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();
  let { id } = useParams();

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
  };

  return (
    <>
    <div className="app-header-wrapper">

          <div className="header-logo">
            <img src={orologo} alt="logo" />
          </div>

          <div className="header-text">
              <Typography variant="h4" sx={{ textTransform: "uppercase" }}>
              {t("header_subtitle")}
            </Typography>
            <Typography variant="body1" sx={{ textTransform: "uppercase" }}>
              {t("header_title")}
            </Typography>
          </div>

          <div className="header-logo">
            <img src={mpcst} alt="logo" />
          </div>
          </div>
<div className="header-menu-language">
        <div className="header-mainefooter">
          <Link to="/">{t("footer_home")}</Link>
          <Link to="/about">{t("footer_about")}</Link>
          <Link to="/More">{t("footer_more")}</Link>
        </div>
  <div className="header-lanuage">
            <FormControl 
             sx={{
    minWidth: 120,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "white",
      },
    },
  }}
            >

              <InputLabel>{t("language_label")}</InputLabel>

              <Select
                value={language}
                label={t("language_label")}
                onChange={handleLanguageChange}
                 sx={{
    color: "white",
    ".MuiSvgIcon-root": {
      color: "white",   // 👈 arrow color
    },
  }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="hi">Hindi</MenuItem>
              </Select>

            </FormControl>
          </div>
          </div>
     </>   
  )
}

export default Header